import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { TaskStatusDataDc } from "@evergis/api";
import { useTranslation } from "react-i18next";

import { useDialogReset } from "../../../../hooks/useDialogs";
import { setNotificationPayload } from "../../../../ducks/notifications/notifications";
import { createNotificationFail } from "../../../../evergis/core/tools/createToolsNotifications";

const EDIT_ATTRIBUTES_PROCESS = "edit-attributes-process";
const EDIT_ATTRIBUTES_CANCEL = "edit-attributes-cancel";

export const EDIT_ATTRIBUTES_SUCCESS = "edit-attributes-success";

export const useEditAttributesNotifications = (taskResult: TaskStatusDataDc, error: Error) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const closeDialog = useDialogReset();

  useEffect(() => {
    if (taskResult && taskResult.taskId) {
      closeDialog();

      dispatch(
        setNotificationPayload({
          taskId: taskResult.taskId,
          info: {
            id: EDIT_ATTRIBUTES_PROCESS,
            title: t("featuresMultiEdit.attributesEdit", { ns: "dialogs" }),
            progress: true,
            duration: null,
            button: t("actions.cancel", { ns: "common" }),
          },
          success: {
            id: EDIT_ATTRIBUTES_SUCCESS,
            title: t("featuresMultiEdit.calculationComplete", { ns: "dialogs" }),
            success: true,
            button: t("actions.cancel", { ns: "common" }),
          },
          cancel: {
            id: EDIT_ATTRIBUTES_CANCEL,
            title: t("featuresMultiEdit.calculationCancelled", { ns: "dialogs" }),
          },
          fail: createNotificationFail(error, {
            title: t("featuresMultiEdit.attributeEditError", { ns: "dialogs" }),
            description: t("featuresMultiEdit.tryAgain", { ns: "dialogs" }),
          }),
        }),
      );
    }
  }, [taskResult, t]);
};
